import { useEffect } from 'react';
import lottie from 'lottie-web/build/player/lottie_light';
import loadingJson from './loading.json.js';

function LoadingSpinnerSvg(_a) {
    var container = _a.container;
    useEffect(function () {
        if (container instanceof HTMLElement) {
            var anim_1 = lottie.loadAnimation({
                container: container,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: loadingJson,
                rendererSettings: {
                    viewBoxSize: '100 50 100 50',
                },
            });
            return function () {
                anim_1.destroy();
            };
        }
        return undefined;
    }, [container]);
    return null;
}

export { LoadingSpinnerSvg as default };
